(function () {
  var NAME_SELECTOR = '[name="properties[Name]"]';
  var AGE_SELECTOR = '[name="properties[Age]"]';
  var INSTRUCTIONS_SELECTOR = '[name="properties[Special Instructions]"]';

  function closestForm(node) {
    return node && node.closest ? node.closest('form') : null;
  }

  function getVisibleFields(form) {
    var scope = form || document;
    var nameInput = scope.querySelector(NAME_SELECTOR + ':not([type="hidden"])') || document.querySelector(NAME_SELECTOR + ':not([type="hidden"])');
    var ageInput = scope.querySelector(AGE_SELECTOR + ':not([type="hidden"])') || document.querySelector(AGE_SELECTOR + ':not([type="hidden"])');
    var instructionsInput = scope.querySelector(INSTRUCTIONS_SELECTOR + ':not([type="hidden"])') || document.querySelector(INSTRUCTIONS_SELECTOR + ':not([type="hidden"])');

    if (!nameInput || !ageInput) return null;

    return {
      nameInput: nameInput,
      ageInput: ageInput,
      instructionsInput: instructionsInput,
      box: nameInput.closest('[data-banner-personalisation]')
    };
  }

  function showError(fields, message, focusEl) {
    if (!fields) return;
    var errorEl = fields.box && fields.box.querySelector('[data-banner-error]');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    fields.nameInput.classList.toggle('is-error', !String(fields.nameInput.value || '').trim());
    var ageValue = String(fields.ageInput.value || '').trim();
    var ageNumber = parseInt(ageValue, 10);
    var ageInvalid = !ageValue || isNaN(ageNumber) || ageNumber < 1 || ageNumber > 99;
    fields.ageInput.classList.toggle('is-error', ageInvalid);

    if (fields.box) {
      fields.box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (focusEl && typeof focusEl.focus === 'function') focusEl.focus();
  }

  function clearError(fields) {
    if (!fields) return;
    var errorEl = fields.box && fields.box.querySelector('[data-banner-error]');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
    fields.nameInput.classList.remove('is-error');
    fields.ageInput.classList.remove('is-error');
  }

  function validateFields(form) {
    var fields = getVisibleFields(form);
    if (!fields) return { valid: true };

    var nameValue = String(fields.nameInput.value || '').trim();
    var ageValue = String(fields.ageInput.value || '').trim();
    var ageNumber = parseInt(ageValue, 10);

    if (!nameValue) {
      showError(fields, 'Please enter the name for this banner.', fields.nameInput);
      return { valid: false, fields: fields };
    }

    if (!ageValue || isNaN(ageNumber) || ageNumber < 1 || ageNumber > 99) {
      showError(fields, 'Please enter an age between 1 and 99.', fields.ageInput);
      return { valid: false, fields: fields };
    }

    clearError(fields);
    return { valid: true, fields: fields };
  }

  function syncHiddenFields(fields) {
    if (!fields) return;

    document.querySelectorAll(NAME_SELECTOR).forEach(function (input) {
      input.value = fields.nameInput.value;
    });
    document.querySelectorAll(AGE_SELECTOR).forEach(function (input) {
      input.value = fields.ageInput.value;
    });
    if (fields.instructionsInput) {
      document.querySelectorAll(INSTRUCTIONS_SELECTOR).forEach(function (input) {
        input.value = fields.instructionsInput.value;
      });
    }
  }

  function isCheckoutOrAtcTarget(target) {
    if (!target || !target.closest) return false;
    return Boolean(
      target.closest('[name="add"]') ||
      target.closest('.add-to-cart') ||
      target.closest('.shopify-payment-button') ||
      target.closest('.shopify-payment-button__button') ||
      target.closest('[data-shopify="payment-button"]')
    );
  }

  function formNeedsPersonalisation(form) {
    if (!form) return false;
    return Boolean(form.querySelector(NAME_SELECTOR));
  }

  document.addEventListener('input', function (event) {
    if (!event.target.matches || !event.target.matches(NAME_SELECTOR + ', ' + AGE_SELECTOR + ', ' + INSTRUCTIONS_SELECTOR)) {
      return;
    }
    var fields = getVisibleFields(closestForm(event.target) || document);
    if (fields) {
      clearError(fields);
      syncHiddenFields(fields);
    }
  });

  document.addEventListener(
    'click',
    function (event) {
      if (!isCheckoutOrAtcTarget(event.target)) return;

      var form = closestForm(event.target) || document.querySelector('form[data-type="add-to-cart-form"]');
      if (!formNeedsPersonalisation(form)) return;

      var result = validateFields(form);
      if (!result.valid) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return;
      }

      syncHiddenFields(result.fields);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!formNeedsPersonalisation(form)) return;

      var result = validateFields(form);
      if (!result.valid) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return;
      }

      syncHiddenFields(result.fields);
    },
    true
  );
})();
